export default class HotspotController {

  constructor() {
    const hotspotsElems: NodeListOf<HTMLElement> = document.querySelectorAll('.js-hotspots');
    for (let i = 0; i < hotspotsElems.length; i++) {
      this.initHotspotElem(hotspotsElems[i]);
    }
  }

  initHotspotElem(hotspotElem) {
    const allHotspots = hotspotElem.querySelectorAll('.js-hotspots-hotspot');
    const allHotspotMobileTexts = hotspotElem.querySelectorAll('.js-hotspots-hotspot-mobile-text');
    for (let i = 0; i < allHotspots.length; i++) {
      allHotspots[i].addEventListener('click', () => {
        for (let j = 0; j < allHotspots.length; j++) {
          allHotspots[j].classList.remove('hotspots__hotspot--active');
          allHotspotMobileTexts[j].classList.remove('hotspots__hotspotMobileText--active');
        }
        allHotspots[i].classList.add('hotspots__hotspot--active');
        allHotspotMobileTexts[i].classList.add('hotspots__hotspotMobileText--active');
        window.dispatchEvent(new Event('resize'));
      });
    }
  }
}
